// extracted by mini-css-extract-plugin
export default {"textGreen":"textGreen-NYPp_Rmg","textRed":"textRed-JjZMbHah"};